import { getDeviceNo } from '@/utils/wogoo_utils'

const initState = {
  user: {
    userId: '',
    userType: '', // 1-游客用户（跳登录）、2-未绑定手机受限用户（跳绑定手机）
    userName: '',
    font: '2',
    overfont: '2',
    theme: 'light',
    avatar: '',
    authLevel: '',
    connectionType: 'wifi',
    autoLoadResource: true,
    accessToken: '',
    deviceNo: getDeviceNo(),
    deviceType: '',
    systemVersion: '',
    expires: '',
    refreshStatus: false
  }
}
export default initState